module.exports = __webpack_public_path__ + "media/images/CarPrice-bbb26ae8.png";